import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    ejercicio: [],
  },

  getters: {
    getEjercicio: (state) => state.ejercicio,
  },

  mutations: {
    SET_EJERCICIO(state, ejercicio) {
      state.ejercicio = ejercicio;
    },
  },

  actions: {
    async fetchEjercicio({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/ejercicio`)
        .then((response) => {
          commit('SET_EJERCICIO', response.data.data);
        });
    },

    async saveEjercicio(context, ejercicios) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;

      await Promise.all(
        ejercicios.map(async (ejercicio) => {
          await axios
            .post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/ejercicio`, ejercicio);
        }),
      );
    },

    async updateEjercicio(_, ejercicio) {
      await axios
        .put(`PoliciaCuadrantes/C3/historiaClinica/${ejercicio.fk_idHistoriaClinica}/ejercicio/${ejercicio.fk_idEjercicio}`, ejercicio);
    },
  },
};
